export function generateHID(message) {
    let sha256 = require('js-sha256');
    let hash = sha256.create()
    let cd = Date.now()
    hash.update(cd+message)
    // console.log('hash generated: ', hash.hex())
    return hash.hex()
}
export function get_UPAYS_auth() {
    const u = 'mee is a symbol'
    const p = 'just support him'
    return btoa(`${u}:${p}`)
}
/* pk_test_cqmUyqTa7Two0s3KgZFN501U  , use on CLIENT side to init STRIPE elements*/
export function get_UPAYS_TEST() {
    const code = atob(process.env.VUE_APP_UPAYS_TEST)
    let tcode = code.split('meee')
    return tcode[1]
}
/* pk_live_jERUxUfX61ClDyd9I8CdWy4q , use on CLIENT side to init STRIPE elements*/
export function get_UPAYS_LIVE() {
    const code = atob(process.env.VUE_APP_UPAYS_LIVE)
    let lcode = code.split('meee')
    return lcode[1]
}
/* use on SERVER side to proceed STRIPE payment */
export function get_CLIENT_TEST(){
    const code = atob(process.env.VUE_APP_CLIENT_STRIPE_TEST)
    let tcode = code.split('pipi')
    return tcode[1]
}
/* use on SERVER side to proceed STRIPE payment */
export function get_CLIENT_LIVE(){
    const code = atob(process.env.VUE_APP_CLIENT_STRIPE_LIVE)
    let lcode = code.split('pipi')
    return lcode[1]
}
